import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import './spinner-loader.scss';

export interface SpinnerLoaderProps {
  size?: number;
  className?: string;
  color?: string;
}

export const SpinnerLoader: React.FC<SpinnerLoaderProps> = ({
  size = 24,
  className = '',
  color = 'black',
}) => {
  return (
    <div className={`spinner-loader ${className}`}>
      <CircularProgress sx={{ color: color }} size={size} />
    </div>
  );
};
